import { render, staticRenderFns } from "./AssociatedPropertiesCard.vue?vue&type=template&id=0772f63a"
import script from "./AssociatedPropertiesCard.vue?vue&type=script&lang=js"
export * from "./AssociatedPropertiesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports